import React from 'react';
import { useTranslation } from 'react-i18next';

import Loading from '../Common/Loading';

// Types.
import { lsmBillsTableRowTypes } from '../../types/billing';
// Utils.
import { formatDate, setPriceFormat, roundNumber } from '../../utils/billing';

const LSMBillsTableRow: React.FunctionComponent<lsmBillsTableRowTypes> = (props: lsmBillsTableRowTypes) => {
  const { t } = useTranslation();
  const { invoice, desiredPdf, setDesiredPdf } = props;

  const flippedDate = formatDate(invoice.dueDate);
  const formattedPrice = `${setPriceFormat(roundNumber(parseFloat(invoice.invoiceSum)))} €`;

  const invoicePdf = (
    <>
      <a
        href="#root"
        onClick={(e): void => {
          e.preventDefault();
          setDesiredPdf(parseInt(invoice.LSM_invoiceNo));
        }}
        aria-label={`${t('billing:billing.openPdfByDate')} ${flippedDate}`}
      >
        {t('billing:billing.openPdf')}
      </a>
      {desiredPdf && desiredPdf === parseInt(invoice.LSM_invoiceNo) && <Loading size="small" />}
    </>
  );

  return (
    <tr key={`${invoice.LSM_invoiceNo}_${invoice.LSM_contractNo}_${invoice.LSM_LedgerNo}`}>
      <td>{flippedDate}</td>
      <td>{invoice.LSM_contractNo}</td>
      <td>{invoice.LSM_invoiceNo}</td>
      <td>{formattedPrice}</td>
      <td>{invoicePdf}</td>
    </tr>
  );
};

export default LSMBillsTableRow;
